import { css } from 'styled-components';

const sizes = {
  xs: css`
    font-size: 0.625rem;
    line-height: 1.125rem;
  `,
  sm: css`
    font-size: 0.75rem;
    line-height: 1rem;
  `,
  md: css`
    font-size: 0.875rem;
    line-height: 1.375rem;
  `,
  lg: css`
    font-size: 1rem;
    line-height: 1.5rem;
  `,
  xl: css`
    font-size: 1.25rem;
    line-height: 1.75rem;
  `,
  xxl: css`
    font-size: 1.5rem;
    line-height: 2rem;
  `,
  '3xl': css`
    font-size: 1.75rem;
    line-height: 2.25rem;
  `,
  '4xl': css`
    font-size: 2rem;
    line-height: 2.5rem;
  `,
  inherit: css`
    font-size: inherit;
    line-height: inherit;
  `,
};

export { sizes };
